module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAu0lEQVR4AWOgD8i0R0NvZfSwIoo1MKXb6hebJLXpXYlSu2ih+Qa/BsZMu/4ZuluiLDeH2t9zsD2VanItVhOfBo1Sk1vLFD5kpl85e+3WqQsPAr2vp6jj05DcpdnaqHGqJG32oXuL9lw5l+B1NV8Vrw0lxhlVBreigk4dv3Jmx4E7CXZ3pynj08CUaVc/W2NKnf4FJ58Hds7np6vfrFIiEEqsmba2VfpFnTq3k1QvOqq+ktFF00CHiBuUAABTpKxZXhMVEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PT.png
// module id = 1246
// module chunks = 0